import React from "react";
import { Link } from "react-router-dom";
import ImgVisual from "../../assets/Page_3&4/Icon_1.svg";
import ImgVision from "../../assets/Page_3&4/Icon_2.svg";
import ImgRegilla from "../../assets/Page_3&4/Icon_3.svg";
import ImgColor from "../../assets/Page_3&4/Icon_4.svg";
import ImgRueda from "../../assets/Page_3&4/Icon_5.svg";
import ImgMiopia from "../../assets/Page_3&4/Icon_6.svg";



import CardTest from "../CardTest/CardTest";

import "./SectionTests.css";
const SectionTests = () => {
  const cardsTest = [
    {
      id: 1,
      title: "Test de Agudeza Visual a Distancia",
      img: ImgVisual,
      description:
        "Test para medir la claridad con la que ves objetos lejanos. Es fundamental para detectar posibles problemas como la miopía.",
      btn: "Hacer Test",
    },
    {
      id: 2,
      title: "Test de Visión Cercana (Carta Jaeger)",
      img: ImgVision,
      description:
        "Test que evalúa la claridad con la que ves objetos y textos a una distancia de lectura normal. Ideal para adultos mayores de 40 años.",
      btn: "Hacer Test",
    },
    {
      id: 3,
      title: "Test de Rejilla de Amsler",
      img: ImgRegilla,
      description:
        "Una prueba crucial para detectar cambios en la visión central, lo que podría indicar problemas maculares (la parte central de la retina).",
      btn: "Hacer Test",
    },
    {
      id: 4,
      title: "Test de Visión de Color (Ishihara)",
      img: ImgColor,
      description:
        "Test para identificar deficiencias comunes en la visión del color (dificultad para distinguir entre rojos/verdes o azules/amarillos)..",
      btn: "Hacer Test",
    },
    {
      id: 5,
      title: "Test de Rueda de Astigmatismo",
      img: ImgRueda,
      description:
        "Ayuda a identificar indicios de astigmatismo, una imperfección común en la curvatura del ojo que causa visión borrosa o distorsionada.",
      btn: "Hacer Test",
    },
    {
      id: 6,
      title: "Simulación de miopía vs hipermetropía",
      img: ImgMiopia,
      description:
        "Si algunas cosas se ven claras y otras no según la distancia, esta simulación te permitirá diferenciar la miopía y la hipermetropía.",
      btn: "Hacer Test",
    },
  ];
  return (
    <section className="section-tests">
      <h3 className="title-text">Explora nuestros tests visuales</h3>
      <div className="container-tests">
        {cardsTest.map((card) => (
          // img, paragraph, textButton, typeCard
          <Link key={card.id} to={`/tests/${card.id}`} className="tests-link">
            <CardTest
              title={card.title}
              paragraph={card.description}
              textButton={card.btn}
              img={card.img}
              key={card.id}
              typeCard={''}
            />
          </Link>
        ))}
      </div>
    </section>
  );
};

export default SectionTests;
